import { useQuery } from "@tanstack/react-query";
import { myTenantsHierarchyWithCreateRegistrationPermissionQueryOptions } from "../api/registrations";
import { useCurrentCustomer, useCurrentOrganisation } from "../root/CurrentOrganisationProvider";
import { usePermission } from "../shared/permissions";

export const useCanCreateRegistrationsOnOrganisation = () => {
  const currentOrganisation = useCurrentOrganisation();
  const currentCustomer = useCurrentCustomer();
  const { hasPermission } = usePermission();
  const isEnabled =
    currentCustomer.customerKind === "enterprise" && hasPermission("nova-forms-api:registration:create");
  const creatorHierarchyQuery = useQuery({
    ...myTenantsHierarchyWithCreateRegistrationPermissionQueryOptions(),
    enabled: isEnabled,
    throwOnError: false,
  });

  if (isEnabled && creatorHierarchyQuery.isPending) return undefined;
  return (
    creatorHierarchyQuery.data?.id === currentOrganisation.id &&
    hasPermission("nova-forms-api:registration:create", creatorHierarchyQuery.data.permissions)
  );
};
